import { useQuery } from "@tanstack/react-query";
import { GET_DATES_FOR_ATTENDANCE, getAttendanceDate } from "..";

export const useGetAttendanceDateQuery = ({
  attendanceProgramSelected,
  month,
  year,
}) => {
  return useQuery({
    queryKey: [
      GET_DATES_FOR_ATTENDANCE,
      attendanceProgramSelected,
      month,
      year,
    ],
    queryFn: () => getAttendanceDate(attendanceProgramSelected, month, year),
    enabled: !!attendanceProgramSelected,
  });
};
